import { render, staticRenderFns } from "./add-fonts-modal.vue?vue&type=template&id=30f623e9"
import script from "./add-fonts-modal.vue?vue&type=script&lang=js"
export * from "./add-fonts-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports